import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Section, SectionTitle, PageHero, CTA } from "@/components/site/SiteBits";
import { ShoppingCart, Pickaxe, Factory, Pill, Car, Wheat, Cpu, Building, ArrowRight } from "lucide-react";

const IND = [
  { slug: "retail", icon: ShoppingCart, title: "Retail & FMCG", desc: "High-frequency distribution to stores and DCs with on-time reliability." },
  { slug: "mining", icon: Pickaxe, title: "Mining & Minerals", desc: "Heavy and bulk haulage from mine sites to ports and processing." },
  { slug: "manufacturing", icon: Factory, title: "Manufacturing", desc: "Inbound raw materials and outbound finished-goods logistics." },
  { slug: "pharma", icon: Pill, title: "Pharmaceuticals", desc: "Temperature-controlled, compliant cold-chain distribution." },
  { slug: "automotive", icon: Car, title: "Automotive", desc: "Just-in-time parts and vehicle component movement." },
  { slug: "agriculture", icon: Wheat, title: "Agriculture", desc: "Seasonal produce, grain and refrigerated agri-freight." },
  { slug: "technology", icon: Cpu, title: "Technology & Electronics", desc: "Secure, insured handling of high-value cargo." },
  { slug: "construction", icon: Building, title: "Construction", desc: "Materials, equipment and abnormal load transport." },
];

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.06 } }),
};

export default function Industries() {
  return (
    <div>
      <PageHero eyebrow="Industries" title="Logistics tuned to your sector"
        subtitle="We understand the movement, compliance and service demands unique to each industry we serve across Southern Africa."
        image="/industries/manufacturing.jpg" />
      <Section>
        <SectionTitle center eyebrow="Sectors We Serve" title="Specialised solutions by industry" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {IND.map((i, idx) => (
            <motion.div key={i.title} variants={reveal} custom={idx} initial="hidden" whileInView="show"
              viewport={{ once: true, amount: 0.2 }} data-testid={`industry-card-${i.slug}`}>
              <Link to="/services" className="group block relative rounded-2xl overflow-hidden h-64 shadow-sm">
                <img src={`/industries/${i.slug}.jpg`} alt={i.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
                <div className="absolute bottom-0 p-5">
                  <div className="w-9 h-9 rounded-lg bg-primary flex items-center justify-center mb-2">
                    <i.icon size={18} className="text-white" />
                  </div>
                  <h3 className="font-heading font-bold text-white text-lg leading-tight">{i.title}</h3>
                  <p className="text-white/70 text-xs mt-1 line-clamp-2">{i.desc}</p>
                  <span className="mt-2 inline-flex items-center text-xs font-semibold text-white/90 opacity-0 group-hover:opacity-100 transition-opacity">
                    Explore services <ArrowRight size={13} className="ml-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </Section>
      <CTA />
    </div>
  );
}
